/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/bestellung-entry.ts.
 */
import {Artikel} from './artikel';
import {BestellungEntryDtpZusatzdaten} from './bestellung-entry-dtp-zusatzdaten';
import {ImportHinweisOption} from './import-hinweis';

/**
 * Zweck: Beschreibt class BestellungEntry und ihren Daten- oder Funktionsvertrag.
 */
export class BestellungEntry {
  id: number;
  artikel: Artikel;
  menge: number;
  note: string[];
  print_note_lines: any[];
  positionsart: string;
  freimenge: number;
  aktionsrabattmenge: number;
  naturalrabattmenge: number;
  aktionsrabattprozent: number;
  basisverrechnungspreis: number;
  basisverrechnungspreisrabattprozent: number;
  view_slug: string;
  nachliefern: boolean;
  hatImportHinweisZugestimmt: boolean;
  importHinweisOption: ImportHinweisOption;

  dtpErstOderFolgeverschreibungErfassen: boolean;
  dtpErstOderFolgeverschreibung: boolean;
  dtpZusatzdaten: BestellungEntryDtpZusatzdaten[];

  resp_kndnr: string;
  resp_liefermenge: number;
  resp_nachfolgeartikel: Artikel;
  resp_texte: string[];
  resp_detail: {
    Menge: number;
    Lieferzusage: boolean;
    Lieferdatum: string;
    InfoCode: string;
    InfoText: string;
  }[];

  error: string;

  dirty = false;

/**
 * Beschreibt Methode hatProbleme und ihren Rückgabevertrag.
 */
  hatProbleme() {
    let hatProbleme = false;

    if (this.artikel.IstDtpArtikel) {
      hatProbleme = false;
    } else if (this.resp_detail) {
      this.resp_detail.some(d => {
        if (d.Lieferzusage == false) {
          hatProbleme = true;
          return true;
        } else {
          return false;
        }
      });
    } else {
      hatProbleme = false;
    }

    return hatProbleme;
  }

/**
 * Beschreibt Methode getSumme und ihren Rückgabevertrag.
 */
  getSumme() {
    // Nur Vertreter hat einen BVP und keine Liefermenge!
    if (this.basisverrechnungspreis !== null && (this.basisverrechnungspreis > 0 || this.basisverrechnungspreis < 0)) {
      return this.basisverrechnungspreis * this.menge;
    } else {
      return this.artikel.Kundeneinkaufspreis * this.resp_liefermenge;
    }
  }
}
